import { action } from 'typesafe-actions';
import {
  BroadcastPayload,
  BroadcastResponse,
  IBroadcastActionTypes,
} from './Types';

export const getBroadcast = (payload: BroadcastPayload) =>
  action(IBroadcastActionTypes.GET_BROADCAST, payload);
export const getBroadcastSuccess = (response: BroadcastResponse) =>
  action(IBroadcastActionTypes.GET_BROADCAST_SUCCESS, response);
export const getBroadcastFailure = (err: string) =>
  action(IBroadcastActionTypes.GET_BROADCAST_FAILURE, err);

export const getCSV = (payload: BroadcastPayload) =>
  action(IBroadcastActionTypes.GET_CSV, payload);
